module.exports = __webpack_public_path__ + "img/goods.3a3d7866.png";